import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';  // Correct default import for TypeScript

import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-why-sat',
    templateUrl: './why-sat.component.html',
    styleUrls: ['./why-sat.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhySatComponent implements OnInit {
  date: string = moment(new Date()).format('YYYY-MM-DD');
  submitted = false;
  mailSent : boolean = false;
  
  satForm = new UntypedFormGroup({
    pickuploc: new UntypedFormControl(''),
    deliveryloc: new UntypedFormControl(''),
    pickupdate: new UntypedFormControl(''),
    deliverydate: new UntypedFormControl(''),
    reqdesc: new UntypedFormControl(''),
    contactdetails: new UntypedFormControl(''),
    emailid: new UntypedFormControl(''),
    recaptchaReactive : new UntypedFormControl('')
  });

  constructor(private _http: HttpClient, private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.date = moment(new Date()).format('YYYY-MM-DD');

    this.satForm = this.formBuilder.group({
      pickuploc: [''],
      deliveryloc: [''],
      pickupdate: [''],
      deliverydate: [''],
      reqdesc: [''],
      contactdetails: [''],
      recaptchaReactive: ['', [Validators.required]],
      emailid: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    });

  var datefield=document.createElement("input")
    datefield.setAttribute("type", "date")
    if (datefield.type!="date"){ //if browser doesn't support input type="date", load files for jQuery UI Date Picker
        document.write('<link href="http://ajax.googleapis.com/ajax/libs/jqueryui/1.8/themes/base/jquery-ui.css" rel="stylesheet" type="text/css" />\n')
        document.write('<script src="http://ajax.googleapis.com/ajax/libs/jquery/1.4/jquery.min.js"><\/script>\n')
        document.write('<script src="http://ajax.googleapis.com/ajax/libs/jqueryui/1.8/jquery-ui.min.js"><\/script>\n') 
    }

    
  }

  // convenience getter for easy access to form fields
  get f() { return this.satForm.controls; }

  reCaptchaResolved(captchaResponse: string) {
      console.log(`Resolved response token: ${captchaResponse}`);
  }

  submitSatForm() {
    if (this.satForm.invalid) {
      this.submitted = true;
      this.mailSent = false;
      return;
    } else {
      this.submitted = false;
      let frmvalue = this.satForm.value;
      let url = 'https://8csz73bqdj.execute-api.ap-south-1.amazonaws.com/default/emailDispatcher';
      console.log(frmvalue);
      this._http.post(url, frmvalue).subscribe((res:any) => {
      console.log(res);
      if (res['message'] === "success") {
      this.mailSent = true;
      this.satForm.reset();
      }
      })
    }
  }
}
